import Blueline from "../../assets/blueline.svg";
import React, { useState } from "react";
import "./portfolio.css";
import { Projects } from "./projectList";
import link from "../../assets/link.svg";
import { Navigate } from "react-router-dom";

const Portfolio = () => {
  const [hoverId, sethoverId] = useState("");
  return (
    <div className="port">
      <div className="skill-title">
        <div className="name">
          My <span className="blue-text">Projects</span>
        </div>
        <img className="b-line" src={Blueline} alt="line" />
      </div>
      <div className="proj-list">
        {Projects.map((item) => {
          if (item.type === "Android") {
            return (
              <div
                onMouseEnter={() => {
                  sethoverId(item.id);
                }}
                onMouseLeave={() => {
                  sethoverId("");
                }}
                className="andr-container"
              >
                <div
                  className={
                    hoverId === item.id ? "andr-transp-hover" : "andr-transp"
                  }
                >
                  <div className="andr-img-container">
                    <img
                      className={
                        hoverId === item.id ? "and-img3-hover" : "and-img3"
                      }
                      src={item.imgs[2]}
                      alt=""
                    />
                    <img
                      className={
                        hoverId === item.id ? "and-img2-hover" : "and-img2"
                      }
                      src={item.imgs[1]}
                      alt=""
                    />
                    <img
                      className={
                        hoverId === item.id ? "and-img1-hover" : "and-img1"
                      }
                      src={item.imgs[0]}
                      alt=""
                    />
                  </div>
                  <div
                    className={
                      hoverId === item.id ? "and-title-hover" : "and-title"
                    }
                  >
                    {item.title}
                  </div>
                  <div
                    className={
                      hoverId === item.id ? "and-desc-hover" : "and-desc"
                    }
                  >
                    {item.desc}
                  </div>
                  <img
                    className={
                      hoverId === item.id ? "repo-link-hover" : "repo-link"
                    }
                    onClick={() => {
                      window.open(item.url);
                    }}
                    src={link}
                    alt="repo"
                  />
                </div>
              </div>
            );
          }
          if (item.type === "Web") {
            return (
              <div
                onMouseEnter={() => {
                  sethoverId(item.id);
                }}
                onMouseLeave={() => {
                  sethoverId("");
                }}
                className="web-container"
              >
                <div
                  className={
                    hoverId === item.id ? "web-transp-hover" : "web-transp"
                  }
                >
                  <div className="web-img-container">
                    <img
                      className={
                        hoverId === item.id ? "web-img2-hover" : "web-img2"
                      }
                      src={item.imgs[1]}
                      alt=""
                    />
                    <img
                      className={
                        hoverId === item.id ? "web-img1-hover" : "web-img1"
                      }
                      src={item.imgs[0]}
                      alt=""
                    />
                  </div>
                  <div
                    className={
                      hoverId === item.id ? "web-title-hover" : "web-title"
                    }
                  >
                    {item.title}
                  </div>
                  <div
                    className={
                      hoverId === item.id ? "web-desc-hover" : "web-desc"
                    }
                  >
                    {item.desc}
                  </div>
                  <img
                    className={
                      hoverId === item.id ? "repo-link-hover" : "repo-link"
                    }
                    onClick={() => {
                      window.open(item.url);
                    }}
                    src={link}
                    alt="repo"
                  />
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default Portfolio;
